<!-- Adapted from SPlayer 40d9ec6 src/views/Discover/playlists.vue (AGPL-3.0). -->
<template>
  <div class="discover-playlists" :aria-busy="loading">
    <div class="menu">
      <label class="category">分类
        <SaltSelect :value="category" aria-label="歌单分类" @change="selectCategory">
          <option v-for="item in categories" :key="item" :value="item">{{ item === '全部' ? '全部歌单' : item }}</option>
        </SaltSelect>
      </label>
      <div v-if="platform !== 'tx'" class="quality-tabs" role="group" aria-label="歌单类型">
        <SaltButton :style-type="!highQuality ? 'subtle' : 'plain'" :aria-pressed="!highQuality" :class="{ active: !highQuality }" @click="selectQuality(false)">推荐</SaltButton>
        <SaltButton :style-type="highQuality ? 'subtle' : 'plain'" :aria-pressed="highQuality" :class="{ active: highQuality }" @click="selectQuality(true)">精品</SaltButton>
      </div>
    </div>
    <CoverList :items="items" type="playlist" />
    <FeedStatus :loading="loading" :error="error" :more="more" :count="items.length" @retry="loadFeed(items.length > 0)" @more="loadFeed(true)" />
  </div>
</template>
<script>
import { runtime } from '../../bridge';
import { playlistCategories } from '../../playlist-categories';
import catalogFeed, { pushOnlineQuery } from './catalog-feed';
import CoverList from './CoverList.vue';
import FeedStatus from './FeedStatus.vue';
import SaltButton from '../ui/SaltButton.vue';
import SaltSelect from '../ui/SaltSelect.vue';
export default {
  name: 'SPlayerDiscoverPlaylists', mixins: [catalogFeed], components: { CoverList, FeedStatus, SaltButton, SaltSelect },
  data() { return { catalogSettings: runtime.catalogSettings }; },
  computed: {
    platform() { return this.catalogSettings.platform; },
    categories() { return this.platform === 'tx' ? ['全部'] : ['全部', ...playlistCategories.filter(item => item.bigCat !== 'static').map(item => item.name)]; },
    category() { const value = this.$route.query.cat || this.$route.query.category; return this.categories.includes(value) ? value : '全部'; },
    highQuality() { return this.platform !== 'tx' && (this.$route.query.hq === 'true' || this.$route.query.category === '精品歌单'); },
    feedKey() { return [this.platform, this.category, this.highQuality].join(':'); },
  },
  methods: {
    selectCategory(cat) { pushOnlineQuery(this, { onlineTab: 'playlists', cat, category: undefined }); },
    selectQuality(highQuality) { pushOnlineQuery(this, { onlineTab: 'playlists', hq: String(highQuality), category: undefined }); },
    async fetchFeed(cursor) {
      const result = await runtime.catalog(this.highQuality ? 'high-quality-playlists' : 'playlists', undefined, { platform: this.platform, category: this.category, limit: 50, ...(this.highQuality ? { before: cursor } : { offset: cursor }) });
      return { items: result.playlists, more: result.more, nextCursor: result.nextCursor };
    },
  },
};
</script>
<style scoped>
.menu { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 10px; min-height: 40px; }
.category { display:flex; gap:12px; align-items:center; color:var(--salt-subtext,var(--color-secondary)); font-size:12px; }
.quality-tabs { display:flex; gap:4px; }
.quality-tabs button { color:var(--salt-text,var(--color-text)); }
.quality-tabs .active { color:var(--salt-accent,var(--color-primary)); }
button:focus:not(:focus-visible) { outline: none; }
</style>
